import { breakpoints } from 'styles/mq'

import image1a from './images/intro1a.png'
import image1b from './images/intro1b.png'
import image2 from './images/intro2.png'
import image3a from './images/intro3a.png'
import image3b from './images/intro3b.png'
import image3cMobile from './images/intro3c-mobile.png'
import image3c from './images/intro3c.png'
import {
  Image1,
  Image1a,
  Image1b,
  Image2,
  Image3,
  Image3a,
  Image3b,
  Image3c,
  Picture,
} from './styled'
import {
  coumpoundImageVariants,
  slideRightVariants,
  slideTopVariants,
  zoomVariants,
} from './variants'

export const Images = () => (
  <>
    <Image1 variants={coumpoundImageVariants}>
      <Image1a src={image1a} variants={slideRightVariants} alt="" />
      <Image1b src={image1b} variants={slideRightVariants} alt="" />
    </Image1>

    <Image2 src={image2} variants={zoomVariants()} alt="" />

    <Image3 variants={coumpoundImageVariants}>
      <Image3a src={image3a} variants={slideTopVariants} alt="" />
      <Image3b src={image3b} variants={slideTopVariants} alt="" />

      <Picture>
        <source srcSet={image3cMobile} media={breakpoints.smallOnly} />
        <Image3c src={image3c} variants={slideTopVariants} alt="" />
      </Picture>
    </Image3>
  </>
)
